import Bugsnag from '@bugsnag/js';
import { Component, ReactNode } from 'react';

type ErrorBoundaryProps = {
  children: ReactNode;
  fallback?: ReactNode;
  notifyBugsnag?: boolean;
};

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: any) {
    console.error('Caught by ErrorBoundary:', error, errorInfo);

    if (this.props.notifyBugsnag !== false) Bugsnag.notify(error);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback !== undefined ? (
        this.props.fallback
      ) : (
        <div className="fs-12 text-primary">Something went wrong.</div>
      );
    }

    return this.props.children;
  }
}
